module.exports = __webpack_public_path__ + "img/slogan_hover.30197721.png";